import React from 'react';
import { motion } from 'framer-motion';
import { FlowerIcon, BoxIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://pay.hotmart.com/J106967026S';
type CTAButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  icon?: BoxIcon;
  size?: 'md' | 'lg';
  className?: string;
  ariaLabel?: string;
  id?: string;
  checkout?: boolean;
};
export function CTAButton({
  children,
  onClick: _onClick,
  icon: _icon,
  size = 'md',
  className = '',
  ariaLabel,
  id,
  checkout: _checkout
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-10 py-5 text-lg sm:text-xl' : 'px-6 py-3 text-sm sm:text-base';
  return <motion.a id={id} href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`inline-flex items-center justify-center gap-2.5 rounded-full bg-rosa font-medium tracking-wide text-white shadow-lg shadow-rosa/30 transition-colors hover:bg-rosa-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-rosa/40 ${sizing} ${className}`} data-id="element-7" data-mp="33oe7zfpoisun">
      <FlowerIcon className="h-5 w-5 shrink-0 text-crema" strokeWidth={1.8} aria-hidden="true" data-id="element-8" data-mp="1dcb9mpjlr8u6" />
      <span data-id="element-9" data-mp="1n97aqa768sop">{children}</span>
    </motion.a>;
}